/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.orchestrator.segment.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../../validate/validate_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.orchestrator = {};
proto.witbooking.backoffice.orchestrator.segment = {};
proto.witbooking.backoffice.orchestrator.segment.v1 = require('./segment_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.orchestrator.segment.v1.SegmentAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.orchestrator.segment.v1.SegmentAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest,
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse>}
 */
const methodDescriptor_SegmentAPI_GetSegment = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/GetSegment',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest,
  proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest,
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse>}
 */
const methodInfo_SegmentAPI_GetSegment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.segment.v1.SegmentAPIClient.prototype.getSegment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/GetSegment',
      request,
      metadata || {},
      methodDescriptor_SegmentAPI_GetSegment,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.segment.v1.GetSegmentResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.segment.v1.SegmentAPIPromiseClient.prototype.getSegment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/GetSegment',
      request,
      metadata || {},
      methodDescriptor_SegmentAPI_GetSegment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest,
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse>}
 */
const methodDescriptor_SegmentAPI_GetAllSegments = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/GetAllSegments',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest,
  proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest,
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse>}
 */
const methodInfo_SegmentAPI_GetAllSegments = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.segment.v1.SegmentAPIClient.prototype.getAllSegments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/GetAllSegments',
      request,
      metadata || {},
      methodDescriptor_SegmentAPI_GetAllSegments,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.segment.v1.GetAllSegmentsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.segment.v1.SegmentAPIPromiseClient.prototype.getAllSegments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/GetAllSegments',
      request,
      metadata || {},
      methodDescriptor_SegmentAPI_GetAllSegments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest,
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse>}
 */
const methodDescriptor_SegmentAPI_CreateSegment = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/CreateSegment',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest,
  proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest,
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse>}
 */
const methodInfo_SegmentAPI_CreateSegment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.segment.v1.SegmentAPIClient.prototype.createSegment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/CreateSegment',
      request,
      metadata || {},
      methodDescriptor_SegmentAPI_CreateSegment,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.segment.v1.CreateSegmentResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.segment.v1.SegmentAPIPromiseClient.prototype.createSegment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/CreateSegment',
      request,
      metadata || {},
      methodDescriptor_SegmentAPI_CreateSegment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest,
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse>}
 */
const methodDescriptor_SegmentAPI_UpdateSegment = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/UpdateSegment',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest,
  proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest,
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse>}
 */
const methodInfo_SegmentAPI_UpdateSegment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.segment.v1.SegmentAPIClient.prototype.updateSegment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/UpdateSegment',
      request,
      metadata || {},
      methodDescriptor_SegmentAPI_UpdateSegment,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.segment.v1.UpdateSegmentResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.segment.v1.SegmentAPIPromiseClient.prototype.updateSegment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/UpdateSegment',
      request,
      metadata || {},
      methodDescriptor_SegmentAPI_UpdateSegment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest,
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse>}
 */
const methodDescriptor_SegmentAPI_DeleteSegment = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/DeleteSegment',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest,
  proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest,
 *   !proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse>}
 */
const methodInfo_SegmentAPI_DeleteSegment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.segment.v1.SegmentAPIClient.prototype.deleteSegment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/DeleteSegment',
      request,
      metadata || {},
      methodDescriptor_SegmentAPI_DeleteSegment,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.segment.v1.DeleteSegmentResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.segment.v1.SegmentAPIPromiseClient.prototype.deleteSegment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.segment.v1.SegmentAPI/DeleteSegment',
      request,
      metadata || {},
      methodDescriptor_SegmentAPI_DeleteSegment);
};


module.exports = proto.witbooking.backoffice.orchestrator.segment.v1;

